export enum TabPeriod {
  Market = 'MARKET',
  Limit = 'LIMIT',
}

export enum EDITPROPS {
  Deposit = 'Deposit',
  Withdraw = 'Withdraw',
}
